var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-payments-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var step = ref.step;
    var currentStep = ref.currentStep;
    var isPreview = ref.isPreview;
    var completeBrief = ref.completeBrief;
    var patchStep = ref.patchStep;
    var goNextStep = ref.goNextStep;
    var goPreviousStep = ref.goPreviousStep;
    var isLoading = ref.isLoading;
    var isCompletingBrief = ref.isCompletingBrief;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var affiliateLinks = ref.affiliateLinks;
    var discountCodes = ref.discountCodes;
return [_c('activation-brief-payments-view',{attrs:{"brief":brief,"step":step,"is-loading":isLoading,"is-completing-brief":isCompletingBrief,"errors":errors,"error-message":errorMessage,"affiliate-links":affiliateLinks,"discount-codes":discountCodes},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep,"patch-step":patchStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }